import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSUITaxableWagesReport extends Layout {
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceSuiTaxableWages: DataSource;
    textboxDateRange: Textbox;
}
